import { EndpointSetting } from "@/constants/app/type";
import { HotelLocation, HotelState } from "../type";

export const callbackLocationSearch: EndpointSetting['caller'] = (
  state: HotelState,
  action: any,
  endpointName: any
) => {
  const { records, pagination } = action.payload
  if (!state.hotels_locations_search.primaryKeys || action.meta.arg.params.offset === 0) {
    state.hotels_locations_search.primaryKeys = []
  }
  for (let i = 0; i < records.length; i++) {
    const hotel: any = records[i];
    state.hotels_locations_search.data[hotel._id] = hotel
    const indexLocation: number = state.hotels_locations_search.primaryKeys.indexOf(hotel._id)
    if (indexLocation < 0) {
      state.hotels_locations_search.primaryKeys.push(hotel._id)
    }
  }

  state.hotels_locations_search.filter = {
    ...pagination,
    ...action.meta.arg.params
  }
}